var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_sender(),
          value: _vm.tx.counterparty,
          copiable: true
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_amount(),
          value: _vm.i18n.c(_vm.tx.amount) + " " + _vm.tx.asset
        }
      }),
      _vm._v(" "),
      _vm.wallet
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_wallet(),
              value: _vm.wallet,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hash
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_hash(),
              value: _vm.hash,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.internalHash
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_internal_hash(),
              value: _vm.internalHash,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderId
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_order_id(),
              value: _vm.orderId,
              copiable: true
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderAmount
        ? _c("detail", {
            attrs: { prop: _vm.i18n.lbl_order_amount(), value: _vm.orderAmount }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.orderNetwork
        ? _c("detail", {
            attrs: {
              prop: _vm.i18n.lbl_order_network(),
              value: _vm.orderNetwork
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_fixed_fee(),
          value: _vm.i18n.c(_vm.tx.fixedFee) + " " + _vm.tx.asset
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: _vm.i18n.lbl_percent_fee(),
          value: _vm.i18n.c(_vm.tx.percentFee) + " " + _vm.tx.asset
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_date(), value: _vm.tx.date }
      }),
      _vm._v(" "),
      _vm.tx._record.external_details &&
      _vm.tx._record.external_details.aml &&
      _vm.aviliableAml
        ? _c("Aml", { attrs: { score: _vm.riskScore, values: _vm.amlValues } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-599c7830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599c7830","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/history/index/components/Details.Issuance.vue
// module id = RbcP
// module chunks = 1